import React from 'react';
import { connect } from 'react-redux';

import { AsyncComponent, AsyncDomain } from '../../domains/index';

const PROP_NAME_BASE = 'CONDITIONAL_LOADER';

export function copyConfig(config, _count = 0) {
  return {
    condition: config.condition,
    ifTrueOptions: config.ifTrueOptions,
    ifFalseOptions: config.ifFalseOptions,
    propName: `${PROP_NAME_BASE}-${_count}`,
  };
}

function makeMapStateToProps(config) {
  return state => {
    return {
      [config.propName]: config.condition(state),
    };
  };
}

function getComponent(properties, universalProps) {
  if (!properties) return null;
  if (properties.condition && properties.ifTrueOptions) {
    // Allows for deeply nested conditions
    // eslint-disable-next-line no-use-before-define
    return React.createElement(ConditionalLoader(properties, universalProps));
  }
  if (properties.domain) return <AsyncDomain {...properties} {...universalProps} />;
  if (properties.importer) return <AsyncComponent {...properties} {...universalProps} />;
  return null;
}
/*
 * A Higher order component that takes a condition and loads different
 * components based on the truthy value of the condition.
 * The config will be like:
 * {
 *   condition: () => true,
 *     ifTrueOptions: {
 *       domain: 'search',
 *       component: 'SearchContainer'
 *     },
 *     ifFalseOptions: null
 * }
 * ifTrueOptions are passed to either the AsyncComponent or AsyncDomain if the condition
 * is true while ifFalseOptions are passed if the condition is false. See the AsyncDomain/Component
 * for valid props.
 */
export function ConditionalLoader(config, universalProps = {}) {
  const copiedConfig = copyConfig(config);
  const mapStateFunction = makeMapStateToProps(copiedConfig);
  return connect(mapStateFunction, null, null, { pure: false })(props => {
    let propsToRender = null;
    if (props[copiedConfig.propName] && copiedConfig.ifTrueOptions) {
      propsToRender = copiedConfig.ifTrueOptions;
    } else if (copiedConfig.ifFalseOptions) {
      propsToRender = copiedConfig.ifFalseOptions;
    }
    return getComponent(propsToRender, universalProps);
  });
}
